import { CssBaseline, ThemeProvider } from '@mui/material'
import React from 'react'
import { Helmet } from 'react-helmet'
import { Outlet, ScrollRestoration } from 'react-router-dom'

import BusyOverlay from 'components/common/BusyOverlay'
import ToastContainer from 'components/common/ToastContainer'
import EmotionProvider from 'components/EmotionProvider'
import useAuth from 'hooks/use-auth'
import { muiTheme } from 'mui-theme'
import theme from 'theme'

export const AppRoutesWrapper: React.FC = () => {
  const { ready, contractExpirationImminent } = useAuth()
  const expandHeader = contractExpirationImminent

  return (
    <>
      <ScrollRestoration />
      <ToastContainer />
      <Helmet defaultTitle="Gremlin" titleTemplate="%s | Gremlin" />
      <EmotionProvider>
        <ThemeProvider theme={muiTheme}>
          <CssBaseline />
          {ready && (
            <div
              css={[
                {
                  minWidth: theme.bp[0],
                  minHeight: '100vh',
                  display: 'grid'
                },

                expandHeader && {
                  '--info-banner-height': '64px'
                }
              ]}
            >
              <Outlet />
            </div>
          )}
          <BusyOverlay shown={!ready} />
        </ThemeProvider>
      </EmotionProvider>
    </>
  )
}
